import {
    UPDATE_URL
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_URL:
            return {
                ...state,
                SUBMIT_loading: false,
                url: action.url,
            }
        default:
            return state
    }
}